/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entrylinkhint2Inputs */

const en_entrylinkhint2 = /** @type {(inputs: Entrylinkhint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ticket shop or form`)
};

const de_entrylinkhint2 = /** @type {(inputs: Entrylinkhint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ticketshop oder Formular`)
};

/**
* | output |
* | --- |
* | "Ticket shop or form" |
*
* @param {Entrylinkhint2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entrylinkhint2 = /** @type {((inputs?: Entrylinkhint2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entrylinkhint2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entrylinkhint2(inputs)
	return de_entrylinkhint2(inputs)
});
export { entrylinkhint2 as "entryLinkHint" }